import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {KlasifikatoriusApi} from "../api/klasifikatorius.api";
import {TranslateService} from "@ngx-translate/core";
import {GridDataResult} from "@progress/kendo-angular-grid";
import {GiiRegFilterApi} from "../api/gii-registracija-filter.api";
import {State} from "@progress/kendo-data-query";
import {Observable} from "rxjs";
import {GiiRegistracijaService} from "../service/gii-registracija.service";
import {RegPerziuraService} from "../service/reg-perziura.service";
import {SharedDataService} from "../service/shared-data.service";
import {LanguageService} from "../service/language.service";
import {AtaskaitosParametraiApi} from '../api/ataskaitos-parametrai.api';
import {registrationReportsList} from '../enums/registration-reports-enum';
import {KlasifikatoriusService} from "../service/klasifikatorius.service";

@Component({
  selector: 'gii-registracija',
  templateUrl: './gii-registracija.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./gii-registracija.component.css'],
})
export class GiiRegistracijaComponent implements OnInit {
  public page = 0;
  public pageSize = 20;
  public view: Observable<GridDataResult>;
  selectedKodas: string = '';
  selectedPavadinimas: string = '';
  selectedOrderBy: { value: string, text: string } = { value: '', text: '' };
  selectedOrderBy2: { value: string, text: string } = { value: '', text: '' };
  selectedOrderBy3: { value: string, text: string } = { value: '', text: '' };
  selectedBusena: { value: string, text: string } = { value: '', text: '' };
  selectedSrautas: { value: string, text: string } = { value: '', text: '' };
  selectedAtsakBudas: { value: string, text: string } = { value: '', text: '' };
  selectedSubjektoTipas: { value: string, text: string } = { value: '', text: '' };
  busenosList: { text: string; value: string }[] = [];
  subjektoTipasList: { text: string; value: string }[] = [];
  srautaiList: { text: string; value: string }[] = [];
  atsakBudasList: { text: string; value: string }[] = [];
  klasifikatoriusList: KlasifikatoriusApi[] = [];
  public showExportDialog = false;
  orderBy: any[] = [{}];
  orderBy2: any[] = [{}];
  orderBy3: any[] = [{}];
  public state: State = {
    skip: 0,
    take: 20,
  };
  ataskaitosParametrai = new AtaskaitosParametraiApi((new Date().getFullYear() - 1).toString());

  constructor(private translate: TranslateService,
              public giiRegService: GiiRegistracijaService,
              public regPerziuraService: RegPerziuraService,
              public sharedDataService: SharedDataService,
              private languageService: LanguageService,
              private klasifikatoriusService: KlasifikatoriusService) {
    this.view = giiRegService;
    const filterParams: GiiRegFilterApi = {
      tipas: this.selectedSubjektoTipas.value,
      kodas: this.selectedKodas,
      pavadinimas: this.selectedPavadinimas,
      srautas: this.selectedSrautas.value,
      busena: this.selectedBusena.value,
      atsakBudas: this.selectedAtsakBudas.value,
      orderBy: this.selectedOrderBy.value,
      orderBy2: this.selectedOrderBy2.value,
      orderBy3: this.selectedOrderBy3.value,
      page: this.page,
      pageSize: this.pageSize
    };
    this.giiRegService.queryFilteredGiiReg(filterParams);
    this.ataskaitosParametrai.registracijosDataNuo = new Date('2024-04-01')
    this.ataskaitosParametrai.registracijosDataIki = new Date();
  }

  ngOnInit(): void {
    this.sharedDataService.getklasifikatoriusApiSubject().subscribe((data: KlasifikatoriusApi[]) => {
      this.klasifikatoriusList = data;
    });

    this.refreshLists();

    this.translate.onLangChange.subscribe((event) => {
      this.refreshLists()
    });

  }

  private refreshLists(): void {
    this.atsakBudasList = this.klasifikatoriusService.prepareClFilterList(this.klasifikatoriusList, 'CL124', 'IN');
    this.srautaiList = this.klasifikatoriusService.prepareClFilterList(this.klasifikatoriusList, 'CL123');
    this.updateSubjektoTipasList();
    this.updateBusenosList();
    this.updateOrderByList();
  }


  updateOrderByList() {
    const emptySelection = { value: '', text: '' };

    this.orderBy = [
      emptySelection,
      { text: this.translate.instant('label.order.reg.data.desc'), value: 'regDataNoTime desc' },
      { text: this.translate.instant('label.order.reg.data.asc'), value: 'regDataNoTime asc' },
      { text: this.translate.instant('label.order.sbj.kodas.desc'), value: 's.kodas asc' },
      { text: this.translate.instant('label.order.sbj.kodas.asc'), value: 's.kodas desc' },
      { text: this.translate.instant('label.order.sbj.pavadinimas.desc'), value: 's.pavadinimas asc' },
      { text: this.translate.instant('label.order.sbj.pavadinimas.asc'), value: 's.pavadinimas desc' },
      { text: this.translate.instant('label.order.srautas.asc'), value: 'sraut.pavadinimas asc' },
      { text: this.translate.instant('label.order.srautas.desc'), value: 'sraut.pavadinimas desc' },
    ];
    this.selectedOrderBy = emptySelection;
    this.selectedOrderBy2 = emptySelection;
    this.selectedOrderBy3 = emptySelection;
  }

  updateSubjektoTipasList() {

    this.subjektoTipasList = [
      { text: '', value: '' },
      { text: this.translate.instant('label.tipas.FA'), value: 'FA' },
      { text: this.translate.instant('label.tipas.JA'), value: 'JA' },
      { text: this.translate.instant('label.tipas.UZ'), value: 'UZ' },
    ];
  }

  updateBusenosList() {

    this.busenosList = [
      { text: '', value: '' },
      { text: this.translate.instant('label.busena.RN'), value: 'RN' },
      { text: this.translate.instant('label.busena.UZ'), value: 'UZ' },
      { text: this.translate.instant('label.busena.VS'), value: 'VS' },
    ];
  }

  onRowSelect(row: any): void {
    this.regPerziuraService.openRegPerziura(row.id, row.srautoKodas);
  }

  onFilterClicked(): void {
    this.filterData();
  }

  filterData() {
    this.page = 0;
    this.state.skip = 0;
    const filterParams: GiiRegFilterApi = {
      tipas: this.selectedSubjektoTipas.value,
      kodas: this.selectedKodas,
      pavadinimas: this.selectedPavadinimas,
      srautas: this.selectedSrautas.value,
      busena: this.selectedBusena.value,
      atsakBudas: this.selectedAtsakBudas.value,
      orderBy: this.selectedOrderBy.value,
      orderBy2: this.selectedOrderBy2.value,
      orderBy3: this.selectedOrderBy3.value,
      page: this.page,
      pageSize: this.pageSize
    };
    this.giiRegService.queryFilteredGiiReg(filterParams);
  }

  filterOrderBy2(orderBy: string, orderBy3: string): void {
    const empty = { value: '', text: '' };
    if (orderBy) {
      this.orderBy2 = this.orderBy.filter((item) => !item.value.includes(orderBy.split(" ")[0]));
      this.selectedOrderBy2 = empty;
      this.selectedOrderBy3 = empty;
    } else {
      this.orderBy2 = [{}];
      this.selectedOrderBy2 = empty;
      if (orderBy3) {
        this.orderBy3 = [{}];
        this.selectedOrderBy3 = empty;
      }
    }
  }
  filterOrderBy3(orderBy: string, orderBy2: string): void {
    const empty = { value: '', text: '' };
    if (orderBy2) {
      this.orderBy3 = this.orderBy.filter((item) => !item.value.includes(orderBy2.split(" ")[0]) && !item.value.includes(orderBy.split(" ")[0]));
      this.selectedOrderBy3 = empty;
    } else {
      this.orderBy3 = [{}];
      this.selectedOrderBy3 = empty;
    }
  }

  onPageChanged(event: any): void {
    this.state.skip = event.skip;
    this.pageSize = event.take;
    this.page = (event.skip / this.pageSize);
    const filterParams: GiiRegFilterApi = {
      tipas: this.selectedSubjektoTipas.value,
      kodas: this.selectedKodas,
      pavadinimas: this.selectedPavadinimas,
      srautas: this.selectedSrautas.value,
      busena: this.selectedBusena.value,
      atsakBudas: this.selectedAtsakBudas.value,
      orderBy: this.selectedOrderBy.value,
      orderBy2: this.selectedOrderBy2.value,
      orderBy3: this.selectedOrderBy3.value,
      page: this.page,
      pageSize: this.pageSize
    };
    this.giiRegService.queryFilteredGiiReg(filterParams);
  }

  openExportDialog(): void {
    this.showExportDialog = true;
  }

  closeExportDialog(): void {
    this.showExportDialog = false;
  }

  protected readonly reports = registrationReportsList;
}
